export default __webpack_public_path__ + "static/media/check.7cd9465e.svg";